import { toastController } from "@ionic/vue";
import notify from "devextreme/ui/notify";

export async function presentToast(
  message: string,
  color: string,
  position: any
) {
  const toast = await toastController.create({
    color: color,
    message: message,
    duration: 1500,
    position: position,
  });

  await toast.present();
}

export function customNotify(
  message: string,
  color: string,

  duration?: number
) {
  notify(
    {
      message: message,
      position: {
        my: "bottom center",
        at: "bottom center",
      },
    },
    color,
    duration == null ? 3000 : duration
  );
}
